angular.module('env.custom.customModule.signup', [])

    .config(function ($stateProvider) {
        $stateProvider.state('signup', {
            url: '/signup',
            templateUrl: 'branding/footlink/signup/signup.html',
            controller: 'SignupController',
            data: { pageTitle: 'OrderManager: Sign Up' },
            resolve: {
                loadingWaiter: function () {
                    //hack that will hide loading screen, when main state is ready
                    if (window.omHideLoadingScreenCallback) {
                        window.omHideLoadingScreenCallback();
                    }
                }
            }
        });
    })

    .controller('SignupController', function SignupController($q, $log, $scope, $state, $http, $localStorage, $timeout, authService, toastr, gettextCatalog, signupService) {
        $scope.isBusy = false;
        $scope.isRequestingCode = false;
        $scope.isRegisteredCompanyNameFetching = false;
        $scope.userInfo = {};
        $scope.isConfirmationCodeRequested = false;
        $scope.termsAccepted = false;
        $scope.loginUrl = window.location.href.replace("signup", "login");
        $scope.userABNValidForCreation = true;
        $scope.suggestedAddresses = [];

        var focusTimeout;
        var ddlKeydownHandler;

        $scope.$on('$destroy', function () {
            $timeout.cancel(focusTimeout);
        });

        $scope.signupValidatorOptions = {
            rules: {
                validabn: function (input) {
                    //Check the abn input
                    if (input.is("[name=clinicABN]")) {
                        var isValid = $scope.isValidABN(input.val());
                        if (isValid) {
                            //Spin off the registered company name fetching
                            fetchRegisteredCompanyName(input.val());
                        }
                        return isValid;
                    }
                    //And return true for all other inputs as every input is checked against custom rule
                    return true;
                },
                validregname: function (input) {
                    if (input.is("[name=clinicName]")) {
                        return !_.str.isBlank($scope.userInfo.clinicName); //mark the input field as not valid if the model value is empty
                    }
                    //And return true for all other inputs as every input is checked against custom rule
                    return true;
                }
            }
        };

        $scope.goBack = function () {
            $state.go('login');
        }

        $scope.isFormValid = function () {
            var uInfo = $scope.userInfo;

            return !angular.isUndefined(uInfo) &&
                !angular.isUndefined(uInfo.firstName) && uInfo.firstName.length !== 0 &&
                !angular.isUndefined(uInfo.lastName) && uInfo.lastName.length !== 0 &&
                !angular.isUndefined(uInfo.clinicName) && uInfo.clinicName.length !== 0 &&
                !angular.isUndefined(uInfo.clinicTradingName) && uInfo.clinicTradingName.length !== 0 &&
                !angular.isUndefined(uInfo.clinicAddress) && uInfo.clinicAddress.length !== 0 &&
                !angular.isUndefined(uInfo.clinicCity) && uInfo.clinicCity.length !== 0 &&
                !angular.isUndefined(uInfo.clinicState) && uInfo.clinicState.length !== 0 &&
                !angular.isUndefined(uInfo.clinicPostcode) && uInfo.clinicPostcode.length !== 0 &&
                !angular.isUndefined(uInfo.clinicPhone) && uInfo.clinicPhone.length !== 0 &&
                !angular.isUndefined(uInfo.clinicEmail) && uInfo.clinicEmail.length !== 0 &&
                !angular.isUndefined(uInfo.clinicAccountsEmail) && uInfo.clinicAccountsEmail.length !== 0 &&
                $scope.isValidABN(uInfo.clinicABN);
        }

        $scope.isValidABN = function (abnToValidate) {
            if (!abnToValidate) {
                return false;
            }
            //we need this to create a copy of string to avoid any infinite digest loops if that string was used in a bindings
            var abnValue = abnToValidate.toString().slice().replaceAll(' ', '');
            if (abnValue.length !== 11) {
                return false;
            }

            var abnResult = false;
            var weights = new Array(10, 1, 3, 5, 7, 9, 11, 13, 15, 17, 19);
            var firstDigit = abnValue.toString().substring(0, 1);
            var restDigits = abnValue.toString().substring(1);

            if (parseInt(firstDigit) === 0) {
                abnResult = false;
            }
            var abn = parseInt(firstDigit - 1).toString() + restDigits;
            var total = 0;
            for (var i = 0; i < 11; i++) {
                total += weights[i] * parseInt(abn.charAt(i));
            }

            if (total === 0 || total % 89 !== 0) {
                abnResult = false; //Not valid ABN
            } else
                abnResult = true; //Valid ABN

            return abnResult;
        }

        function fetchRegisteredCompanyName(abnValue) {
            $scope.isRegisteredCompanyNameFetching = true;

            $http.post(om.config.build.baseUrl + "/rest-proxy/do-get-request",
                {
                    uri: 'https://abr.business.gov.au/json/AbnDetails.aspx?abn=' + abnValue + '&guid=2c1e5a9d-d9b2-41cc-8e20-f1a6b19e6ea8'
                })
                .then(
                    function (response) {
                        var data = response.data;
                        try {
                            var registeredName = '';
                            if (data.indexOf('callback(') === 0) { //if we have expected response from server with json object
                                var reJsonObject = /{.*}/gm;
                                var jsonObjectMatch = data.match(reJsonObject);
                                if (jsonObjectMatch && jsonObjectMatch[0]) {
                                    //parse json string into object and get registered name from it
                                    registeredName = parseRegisteredCompanyName(jsonObjectMatch[0]);
                                    $scope.$applyAsync(function () { $scope.userInfo.clinicName = registeredName; });
                                }
                            }
                            //Show an error if we still were not able to get the registered name
                            if (_.str.isBlank(registeredName)) {
                                toastr.error(
                                    'ABN service is not available or there is no information for specified ABN.',
                                    gettextCatalog.getString('Registered Company Name can not be fetched'));
                            } else {
                                //As we have a proper name for the company, we may want now to validate ABN
                                $q.all([
                                    signupService.validateUserFieldValue(abnValue.replaceAll(' ', ''), "Name"),
                                    signupService.validateCustomerFieldValue(abnValue.replaceAll(' ', ''), "ReckonAccountsCode")
                                ])
                                    .then(function (data) {
                                            $scope.userABNValidForCreation = data[0] === true && data[1] === true;
                                            
                                            if (!$scope.userABNValidForCreation) {
                                                //do nothing as we will show a modal dialog form to the user in that case
                                            }
                                            $scope.isRegisteredCompanyNameFetching = false; //we have finished fetching/validation
                                        },
                                        function (error) {
                                            //Alert user about the fact of error
                                            toastr.error('Error happened while we tried to validate your ABN. Please contact administrator.',
                                                gettextCatalog.getString('Error during ABN validation'));
                                            $scope.isRegisteredCompanyNameFetching = false;
                                            $scope.userABNValidForCreation = false;
                                        });
                            }
                        } catch (error) {
                            toastr.error('Unknown error during ABN processing.',
                                gettextCatalog.getString('Registered Company Name can not be fetched'));
                        }
                    }, function (error) {
                        //var errorData = error.data;
                        //Simulate text field focus/blur so the validation message of this input field will be shown
                        //We need to switch off and switch on the 'disable' attribute in order for the focus/blur trick to work
                        if (angular.element(document.querySelector("#clinicName")).length !== 0) {
                            angular.element(document.querySelector("#clinicName"))[0].disabled = '';
                            angular.element(document.querySelector("#clinicName"))[0].focus();
                            focusTimeout = $timeout(function () {
                                angular.element(document.querySelector("#clinicName"))[0].blur();
                                angular.element(document.querySelector("#clinicName"))[0].disabled = 'disabled';
                            });
                        }
                        $scope.isRegisteredCompanyNameFetching = false;
                        toastr.error('ABN service is not available or there is no information for specified ABN.', gettextCatalog.getString('Registered Company Name not found'));
                    });
        }

        function parseRegisteredCompanyName(abnApiResponseString) {
            var jResponse = JSON.parse(abnApiResponseString);

            return jResponse != null && !_.str.isBlank(jResponse.EntityName) ? jResponse.EntityName : null;
        }

        function checkFormValidity() {
            if (!$scope.isFormValid($scope.userInfo) || !$scope.signupValidator.validate()) {
                var msg = gettextCatalog.getString('Some of the information you have entered is not valid. Please review it and try again.');
                toastr.error(msg, gettextCatalog.getString('Registration form is missing some information'));
                $scope.isBusy = false;
                $scope.isSigningUp = false;
                return false;
            }
            return true;
        }

        $scope.getSuggestions = _.debounce(function () { getSuggestedAddresses(); }, 250);

        $scope.onAddressClick = function() {
            var ddl = $("#ddlAddresses").data("kendoDropDownList");
            if (ddl && $scope.suggestedAddresses && $scope.suggestedAddresses.length > 0) {
                ddl.open();
                ddl.focus();

                if (!ddlKeydownHandler) {
                    ddlKeydownHandler = function(e) {
                        if (e && ((e.keyCode && e.keyCode === 8) || (e.key && e.key === "Backspace"))) {
                            $("#clinicAddress").focus();
                        }
                    };
                    $("#ddlAddresses").closest('.k-dropdown.k-widget').keydown(ddlKeydownHandler);
                }
            } else if(ddl) {
                ddl.close(); //close it in case it was opened
            }
        }

        function getSuggestedAddresses() {
            if (!$scope.userInfo.clinicAddress || $scope.userInfo.clinicAddress.length < 4) {
                return; //do not request suggestions if the address entered too short
            }

            signupService.getSuggestedAddresses($scope.userInfo.clinicAddress,
                    $scope.userInfo.clinicCity,
                    $scope.userInfo.clinicState)
                .then(function(data) {
                        if (data && data.suggest) {
                            $scope.$applyAsync(function() {
                                $scope.suggestedAddresses = data.suggest;
                                $scope.suggestedAddressesOptions = {
                                     select: onSuggestedAddressSelect,
                                     dataBound: onSuggestedAddressesDataBound
                                };
                            });
                        }
                    },
                    function(resp) {
                        var msg;
                        if (resp && resp.messages && resp.messages.length > 0 && _.isString(resp.messages[0]) && resp.messages[0].length < 256) {
                            msg = resp.messages[0];
                        } else {
                            msg = gettextCatalog.getString('No address suggestions found or error happened during suggestions request.');
                        }
                        $log.warn("%s. Details: %s %s %s", msg, $scope.userInfo.cinicAddress, $scope.userInfo.cinicCity, $scope.userInfo.cinicState);
                    });
        }

        function onSuggestedAddressesDataBound() {
            $scope.onAddressClick();
        }

        function onSuggestedAddressSelect(e) {
            if (e && e.dataItem && e.dataItem.address) {
                try {
                    //parse address string and fill in the corresponding fields
                    var rePostCode = /\s+(?:(?:[2-8]\d|9[0-7]|0?[28]|0?9(?=09))(?:\d{2}))\s*/ig;
                    var reState = /\s+(ACT|NSW|NT|QLD|SA|TAS|VIC|WA)\s*/ig;
                    var street = e.dataItem.address.substr(0, e.dataItem.address.indexOf(','));
                    var rest = e.dataItem.address.substr(e.dataItem.address.indexOf(',') + 1);

                    var mState = rest.match(reState);
                    if (mState && mState.length > 0 && mState[0]) {
                        $scope.userInfo.clinicState = mState[0].trim();
                        rest = rest.replace(reState, ' ');
                    }

                    var mPostCode = rest.match(rePostCode);
                    if (mPostCode && mPostCode.length > 0 && mPostCode[0]) {
                        $scope.userInfo.clinicPostcode = mPostCode[0].trim();
                        rest = rest.replace(rePostCode, '');
                    }

                    $scope.userInfo.clinicAddress = street.trim();
                    $scope.userInfo.clinicCity = rest.trim();
                } catch (e) {
                    $log.error("Something went wrong during parsing of the address data.", e);
                }
            }
        }

        $scope.signup = function () {
            if (!checkFormValidity()) {
                return;
            }

            $scope.isBusy = true;
            $scope.isSigningUp = true;

            signupService.submitUserRegistrationInfo(
                $scope.userInfo.confirmationCode,
                $scope.userInfo.clinicABN.replaceAll(' ', ''),
                {
                    name: $scope.userInfo.clinicABN.replaceAll(' ', ''),
                    lastName: $scope.userInfo.lastName,
                    firstName: $scope.userInfo.firstName,
                    email: $scope.userInfo.clinicEmail,
                    culture: 'en-AU'
                },
                {
                    line1: $scope.userInfo.clinicAddress,
                    line2: '',
                    city: $scope.userInfo.clinicCity,
                    companyName: $scope.userInfo.clinicTradingName,
                    contactLastName: $scope.userInfo.lastName,
                    contactFirstName: $scope.userInfo.firstName,
                    country: 'Australia',
                    email: $scope.userInfo.clinicEmail,
                    postalCode: $scope.userInfo.clinicPostcode,
                    region: $scope.userInfo.clinicState,
                    telephone: $scope.userInfo.clinicPhone
                },
                [
                    { fieldCode: 'Class', type: 'string', value: 'iPad' },
                    { fieldCode: 'DeviceId', type: 'string', value: 'Own' },
                    { fieldCode: 'WaitingClass', type: 'string', value: 'NotWaiting' }
                ],
                [
                    { fieldCode: 'ReckonAccountsCode', type: 'string', value: $scope.userInfo.clinicABN.replaceAll(' ', '') },
                    { fieldCode: 'RegisteredCompanyName', type: 'string', value: $scope.userInfo.clinicName },
                    { fieldCode: 'AccountsEmail', type: 'string', value: $scope.userInfo.clinicAccountsEmail },
                    { fieldCode: 'OwnerEmail', type: 'string', value: $scope.userInfo.clinicAccountsEmail },
                    { fieldCode: 'DeliveryMethod', type: 'string', value: 'AUSPost' },
                    { fieldCode: 'NextDayDelivery', type: 'string', value: 'EveryDay' }
                ]
            )
                .then(
                    function () {
                        $scope.registrationFormSent = true;
                        $scope.isBusy = false;
                        $scope.isSigningUp = false;
                    },
                    function (resp) {
                        var data = resp.data;
                        var msg;
                        if (data && data.error && _.isString(data.error)) {
                            msg = data.error;
                        } else if (data && _.isString(data) && data.length > 0 && data.length < 256) {
                            msg = data;
                        } else {
                            msg = gettextCatalog.getString('Registration form submission failed due to an error. Please review the form and try again later.');
                        }
                        toastr.error(msg, gettextCatalog.getString('Sign-up failed'));
                        $scope.isBusy = false;
                        $scope.isSigningUp = false;
                        $scope.registrationFormSent = false;
                    });
        };

        $scope.requestConfirmationCode = function () {

            if (!checkFormValidity()) {
                return;
            }

            $scope.isRequestingCode = true;

            signupService.requestEmailConfirmationCode($scope.userInfo.clinicEmail, $scope.userInfo.firstName, $scope.userInfo.lastName)
                .then(
                    function () {
                        $scope.confirmationCodeSent = true;
                        $scope.isRequestingCode = false;
                    },
                    function (resp) {
                        var data = resp.data;
                        var msg;
                        if (data && data.error && _.isString(data.error)) {
                            msg = data.error;
                        } else if (data && _.isString(data) && data.length > 0 && data.length < 256) {
                            msg = data;
                        } else {
                            msg = gettextCatalog.getString("Request to send confirmation code failed due to an error");
                        }
                        toastr.error(msg, gettextCatalog.getString("Request failed"));
                        $scope.isRequestingCode = false;
                        $scope.confirmationCodeSent = false;
                    });

            return;
        };

        $scope.submitContactDetailsOfExistingUser = function() {

            $scope.isBusy = true;

            signupService.submitSupportRequest($scope.userInfo.clinicABN, $scope.userInfo.clinicEmail, $scope.userInfo.clinicPhone)
                .then(
                    function () {
                        $scope.contactRequestSent = true;
                        $scope.isBusy = false;
                    },
                    function (resp) {
                        var data = resp.data;
                        var msg;
                        if (data && data.error && _.isString(data.error)) {
                            msg = data.error;
                        } else if (data && _.isString(data) && data.length > 0 && data.length < 256) {
                            msg = data;
                        } else {
                            msg = gettextCatalog.getString("Contact request sending failed due to unknown error. Please contact Ortesi for instructions.");
                        }
                        toastr.error(msg, gettextCatalog.getString("Sending failed"));
                        $scope.contactRequestSent = false;
                        $scope.isBusy = false;
                    });

            return;
        };
    })

    ;
